import axios from "axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    precio_extras: [],
    precio_extra: {},
  },
  mutations: {
    llenarPreciosExtras(state, data) {
      state.precio_extras = data;
    },
    llenarPrecioExtra(state, data) {
      state.precio_extra = data;
    },
  },
  actions: {
    getPreciosExtras: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;

      await axios
        .get("precio-extra/list", configuracion)
        .then(function(response) {
          response.data.forEach((element) => {
            element.createdAt = moment(element.createdAt).format("LL");
          });
          data = response.data;
          commit("llenarPreciosExtras", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getPrecioExtra: async function({ commit }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      let d = null;

      await axios
        .get(`precio-extra/query?id=${data.id}`, configuracion)
        .then(function(response) {
          d = response.data.detalles;
          commit("llenarPrecioExtra", d);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    savePrecioExtra: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;

      await axios
        .post(
          "precio-extra/add",
          {
            usuario: data.usuario,
            extra: data.obj.extra,
            precio: data.obj.precio,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getPreciosExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El extra ${res.data.nombre} fue agregado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    updatePrecioExtra: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger;
      await axios
        .put(
          "precio-extra/update",
          {
            id: data.obj.id,
            usuario: data.usuario,
            extra: data.obj.extra,
            precio: data.obj.precio,
          },
          configuracion
        )
        .then(function(res) {
          dispatch("getPreciosExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `El precio extra ${res.data.nombre} fue editado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
        });
    },
    deletePrecioExtra: async function({ dispatch }, data) {
      let token = data.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      //debugger
      await axios
        .delete(`precio-extra/remove?id=${data.id}`, configuracion)
        .then(function() {
          dispatch("getPreciosExtras", data.token);
          swal({
            title: "Buen trabajo!",
            text: `Precio Extra eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Lo sentimos!",
            text: `Ha ocurrido un error de tipo ${error}`,
            icon: "error",
          });
          console.log(error);
        });
    },
  },
};
